<script lang="ts">
  /**
 *
 *
 *
 *
 */
</script>

<style lang="scss">
  :host {
    width: 100%;
  }
</style>
